import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { isMobile } from 'react-device-detect';

import { FieldTitle } from '../common';
import UploadForm from './UploadForm';

class Upload extends React.PureComponent {
  constructor() {
    super();

    // These bindings are necessary to make `this` work in the callbacks
    this.openUpload = this.openUpload.bind(this);
  }

  componentDidMount() {
    const { internalTitle, formId } = this.props;

    if (formId) {
      const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
      const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
      // create new container for the upload form
      const uploadForId = `${contentArticleFormId}-${FieldTitle.titleFor('form_upload', formId)}`;
      const el = document.createElement('div');
      el.id = uploadForId;
      el.style = 'position: relative;';

      const formBaseForId = `${contentArticleFormId}-${FieldTitle.titleFor('form_bases', formId)}`;
      const formBase = document.getElementById(formBaseForId);

      // add textual advice for being able to take a photo on mobile devices
      if (isMobile) {
        const $kostencheckUpload = $(`label[for="${forId}"] a`);

        if ($kostencheckUpload.length) {
          $kostencheckUpload.text(`${$kostencheckUpload.text()} oder fotografieren`);
        }
      }

      // insert the new upload form container before the actual form
      formBase.parentNode.insertBefore(el, formBase);

      // render the upload form into the upload form container
      ReactDOM.render(
        <UploadForm formId={formId} contentArticleFormId={this.props.contentArticleFormId} />,
        document.getElementById(uploadForId)
      );
    }
  }

  openUpload() {
    const { formId } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const formBaseForId = `${contentArticleFormId}-${FieldTitle.titleFor('form_bases', formId)}`;
    const $form = $(`#${formBaseForId}`);

    $('.upload-container, .form-overlay').fadeIn(400);
    $('.form-overlay').height($form.height());
    $('.form-overlay').width(`calc(${$form.width()}px + 2%)`);
    $('.upload-container').css('bottom', 'auto');
    $('.upload-container').css({ bottom: 'auto', top: '3em' });
  }

  render() {
    const { internalTitle, options, formId, className } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;

    if (!options) return null;

    const { value, show_label: showLabel, link_value: linkValue, show_link: showLink } = options;

    if (!showLabel && !showLink) return null;

    return (
      <div className={className}>
        <input type="hidden" name="upload_tokens" />
        <div className="form-uploads" />
        <label htmlFor={forId}>
          {!!showLabel && value}
          {!!showLink && linkValue && (
            <a
              className="button button-invert upload"
              href="javascript:void(0);"
              onClick={this.openUpload}
              title={linkValue}
            >
              {linkValue}
            </a>
          )}
        </label>
      </div>
    );
  }
}

Upload.propTypes = {
  internalTitle: React.PropTypes.string,
  options: React.PropTypes.object,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  className: React.PropTypes.string
};

Upload.defaultProps = {
  className: 'formgroup'
};

export default Upload;



// WEBPACK FOOTER //
// ./components/forms/Upload.js